import styled, { css } from 'styled-components';
import Button from '@bitcoin-portal/bitcoincom-pkg-components/dist/Button';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';

interface OptionButtonProps {
  selected: boolean;
}

export const QrCodeModalWrapper = styled.div`
  height: 48px;
  display: flex;
  align-items: center;
  @media only screen and (max-width: 767px) {
    display: none;
  }
`;

export const StyledTitle = styled.div`
  font-weight: 700;
  font-size: 28px;
  line-height: 32px;
  padding: 12px 0px;
`;

export const StyledSubtitle = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  padding: 12px 0px;
`;

export const QrCodeWrapper = styled.div`
  margin: 12px 0px;
  & > div {
    width: 100%;
  }
`;

export const ModalCTA = styled(Button)`
  border-radius: 12px;
  position: relative;
  padding: 0px 14px;
  display: flex;
  align-items: center;

  ${media.lg`
  
  `}

  & > div {
    color: #2d323b;
    font-size: 9px;
    font-weight: 200;
    line-height: 16px;

    ${media.lg`
      font-size: 14px;
      font-weight: 500;
    `}
  }
`;

export const QrImage = styled.img`
  width: 66px;
  height: 66px;
  display: flex;
`;

export const QrText = styled.span`
  white-space: normal;
  text-align: left;
  margin-left: 8px;
`;

export const ModalWrapper = styled.div`
  #inner {
    text-align: center;
    max-height: 603px;
    max-width: 384px;
    border-radius: 13px;
    padding: 32px;
    background-color: #ffffff;
    & > span,
    div {
      color: #2d323b;
    }
  }
`;

export const ToggleWrapper = styled.div`
  background-color: #b0b7c3;
  border-radius: 10px;
  display: flex;
  align-items: center;
  height: 44px;
  width: 288px;
  padding: 4px;
  margin: 12px 0px;
`;

export const OptionButton = styled.div<OptionButtonProps>`
  ${({ selected }) => css`
    background-color: ${selected ? '#ffffff' : 'transparent'};
    border-radius: 8px;
    width: 141px;
    height: 44px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease;
  `}

  input[type=radio] {
    position: fixed;
    opacity: 0;
    pointer-events: none;
  }

  &:first-child {
    margin-right: 8px;
  }

  & > span {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
  }

  & > img {
    margin-right: 8px;
  }
`;
